import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { ArticleCard } from "@/components/ArticleCard";
import { SEO } from "@/components/SEO";

export default function TagPage() {
  const { slug } = useParams();
  const [tag, setTag] = useState(null);
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    api.get("/tags").then(({ data }) => setTag(data.find((t) => t.slug === slug)));
    api.get("/articles", { params: { tag: slug, limit: 24 } }).then(({ data }) => setArticles(data.items));
  }, [slug]);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-testid="tag-page">
      <SEO title={`#${tag?.name || ""}`} description={`Статии с таг ${tag?.name || ""}`} />
      <h1 className="font-serif text-4xl font-bold text-[#10243A] mb-10 pb-4 border-b-2 border-[#C47A35] inline-block" data-testid="tag-title">
        #{tag?.name}
      </h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="tag-articles-grid">
        {articles.map((a) => <ArticleCard key={a.id} article={a} variant="grid" />)}
      </div>
      {articles.length === 0 && <p className="text-[#66717B] mt-6">Все още няма статии с този таг.</p>}
    </div>
  );
}
